export const CLIENT_ID = "CLIENT_ID";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const PROFILE_IMG = "PROFILE_IMG";
export const PERMISSIONS = "MY_PERMISSIONS";
export const GLOBAL_CURRENCY = "GLOBAL_CURRENCY";

export const resetState = () => ({
  type: "RESET_STATE",
});

export const accessToken = (access_token: string) => ({
  type: ACCESS_TOKEN,
  payload: access_token,
});
export const storeClientId = (payload: string) => ({
  type: CLIENT_ID,
  payload: payload,
})
export const handleProfileImg = (payload: string) => (
  {
    type: PROFILE_IMG,
    payload: payload
  })

export const handlePermission = (payload: string) => (
  {
    type: PERMISSIONS,
    payload: payload
  })

export const handleGlobalCurrency = (payload: string) => ({
  type: GLOBAL_CURRENCY,
  payload: payload
})